export function init($name) {
    const pagination = $($name);

    if (!pagination.length) {
      return;
    }

    const currentPageNumber = parseInt(pagination.find('.current').text());

    if (currentPageNumber !== 1) {
        const section = pagination.parents('section');
        const offset = section.offset().top - $('.js-site-header').height() + 27;

        window.HTMLisScrolling = true;

        setTimeout(function() {
            $('html, body').animate({scrollTop: offset}, function() {
                window.HTMLisScrolling = false;
            });
        }, 1000);
    }
}
